import { Flex } from '@/components/common';
import { IntentionBadge } from '@/components/intentions';
import {
  INTENTION_IDS,
  INTENTIONS,
  type IntentionId,
  type IntentionOption,
} from '@/constants/intentions';
import type { UserProfile } from '@/types';

interface UserIntentionsComponentProps {
  user: UserProfile;
  currentUser: UserProfile | null;
}

function isIntentionId(value: string): value is IntentionId {
  return INTENTION_IDS.some(id => id === value);
}

export function UserIntentionsComponent({ user, currentUser }: UserIntentionsComponentProps) {
  const myIntentions = new Set((currentUser?.intentions ?? []).filter(isIntentionId));
  const theirIntentions = (user.intentions ?? [])
    .filter(isIntentionId)
    .map(id => INTENTIONS.find(option => option.id === id))
    .filter((option): option is IntentionOption => Boolean(option));

  if (theirIntentions.length === 0) return null;

  return (
    <Flex
      position="absolute"
      top="2"
      left="2"
      gap="1"
      aria-hidden
      className="pointer-events-none z-10"
    >
      {theirIntentions.map(option => (
        <IntentionBadge
          key={option.id}
          size="1"
          option={option}
          matches={myIntentions.has(option.id)}
        />
      ))}
    </Flex>
  );
}
